.container {
  align-items: center;
  align-self: stretch;
  justify-content: center;
  display: flex;
  background: url('https://res.cloudinary.com/almanac/image/upload/v1749688566/blaze_assets/backgrounds/virtual_marketer_lb0efa.png')
    lightgray 50% / cover no-repeat;
  height: 100vh;
  width: 100vw;

  img {
    width: 75%;
  }
}
